import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { AlertNotificationModel } from '../models';
import { alertNotificationToPayload } from '../mappers';

const getUrl = (host: string) => {
  return `${host}/alert-notifications`;
};

export const CreateAlertNotification = async ({
  host,
  token,
  data,
}: {
  host: string;
  token: string;
  data: AlertNotificationModel;
}): Promise<void> => {
  try {
    const url = getUrl(host);
    const mappedData = alertNotificationToPayload(data);

    const options: AxiosRequestConfig = {
      url,
      method: 'POST',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
      data: { data: mappedData },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
